import {
  ADD_PRE_ASSESSMENT_DATA,
  ADD_PRE_ASSESSMENT_DATA_FAILURE,
  ADD_PRE_ASSESSMENT_DATA_SUCCESS,
  FETCH_PRE_ASSESSMENT_DATA,
  FETCH_PRE_ASSESSMENT_DATA_FAILURE,
  FETCH_PRE_ASSESSMENT_DATA_SUCCESS,
  FETCH_PRE_ASSESSMENT_VIDEO,
  FETCH_PRE_ASSESSMENT_VIDEO_FAILURE,
  FETCH_PRE_ASSESSMENT_VIDEO_SUCCESS,
  ATTEMPT_FAIL_PRE_ASSESSMENT,
  ATTEMPT_FAIL_PRE_ASSESSMENT_SUCCESS,
  ATTEMPT_FAIL_PRE_ASSESSMENT_FAILURE,
  RESET_ADD_PRE_ASSESSMENT_DATA,
  FETCH_PRE_ASSESSMENT_DATA_PUBLIC,
  FETCH_PRE_ASSESSMENT_DATA_PUBLIC_SUCCESS,
  FETCH_PRE_ASSESSMENT_DATA_PUBLIC_FAILURE,
  SEND_PRE_ASSESSMENT_CONSENT_EMAIL,
  SEND_PRE_ASSESSMENT_CONSENT_EMAIL_SUCCESS,
  SEND_PRE_ASSESSMENT_CONSENT_EMAIL_FAILURE,
  RESET_PRE_ASSESSMENT_DATA_VIDEO,
  RESET_PRE_ASSESSMENT_DATA,
  RESET_PRE_ASSESSMENT_VIDEO,
} from "./actionTypes";

export const addPreAssessmentData = (data) => ({
  type: ADD_PRE_ASSESSMENT_DATA,
  payload: data,
});

export const addPreAssessmentDataSuccess = (data) => ({
  type: ADD_PRE_ASSESSMENT_DATA_SUCCESS,
  payload: data,
});

export const addPreAssessmentDataFailure = (error) => ({
  type: ADD_PRE_ASSESSMENT_DATA_FAILURE,
  payload: error,
});

export const fetchPreAssessmentData = (params) => ({
  type: FETCH_PRE_ASSESSMENT_DATA,
  payload: params,
});

export const fetchPreAssessmentDataSuccess = (data) => ({
  type: FETCH_PRE_ASSESSMENT_DATA_SUCCESS,
  payload: data,
});

export const fetchPreAssessmentDataFailure = (error) => ({
  type: FETCH_PRE_ASSESSMENT_DATA_FAILURE,
  payload: error,
});

export const fetchPreAssessmentVideo = (params) => ({
  type: FETCH_PRE_ASSESSMENT_VIDEO,
  payload: params,
});

export const fetchPreAssessmentVideoSuccess = (data) => ({
  type: FETCH_PRE_ASSESSMENT_VIDEO_SUCCESS,
  payload: data,
});

export const fetchPreAssessmentVideoFailure = (error) => ({
  type: FETCH_PRE_ASSESSMENT_VIDEO_FAILURE,
  payload: error,
});

export const attemptFailPreAssessment = (params) => ({
  type: ATTEMPT_FAIL_PRE_ASSESSMENT,
  payload: params,
});

export const attemptFailPreAssessmentSuccess = (data) => ({
  type: ATTEMPT_FAIL_PRE_ASSESSMENT_SUCCESS,
  payload: data,
});

export const attemptFailPreAssessmentFailure = (error) => ({
  type: ATTEMPT_FAIL_PRE_ASSESSMENT_FAILURE,
  payload: error,
});

export const resetAddPreAssessmentData = () => ({
  type: RESET_ADD_PRE_ASSESSMENT_DATA,
});

export const fetchPreAssessmentDataPublic = (params) => ({
  type: FETCH_PRE_ASSESSMENT_DATA_PUBLIC,
  payload: params,
});

export const fetchPreAssessmentDataPublicSuccess = (data) => ({
  type: FETCH_PRE_ASSESSMENT_DATA_PUBLIC_SUCCESS,
  payload: data,
});

export const fetchPreAssessmentDataPublicFailure = (error) => ({
  type: FETCH_PRE_ASSESSMENT_DATA_PUBLIC_FAILURE,
  payload: error,
});

export const sendPreAssessmentConsentEmail = (params) => ({
  type: SEND_PRE_ASSESSMENT_CONSENT_EMAIL,
  payload: params,
});

export const sendPreAssessmentConsentEmailSuccess = (data) => ({
  type: SEND_PRE_ASSESSMENT_CONSENT_EMAIL_SUCCESS,
  payload: data,
});

export const sendPreAssessmentConsentEmailFailure = (error) => ({
  type: SEND_PRE_ASSESSMENT_CONSENT_EMAIL_FAILURE,
  payload: error,
});


export const resetPreAssessmentDataVideo = () => ({
  type: RESET_PRE_ASSESSMENT_DATA_VIDEO,
});


export const resetPreAssessmentData = () => ({
  type: RESET_PRE_ASSESSMENT_DATA,
});


export const resetPreAssessmentVideo = () => ({
  type: RESET_PRE_ASSESSMENT_VIDEO,
});